import { DEFAULT_LOCALE } from '../resources';

const localeToCountryCode: Record<string, string> = {
  en: 'GB',
  nl: 'NL',
  fr: 'FR',
  de: 'DE',
  it: 'IT',
  ja: 'JP',
  ko: 'KR',
  pt: 'PT',
  es: 'ES',
  fi: 'FI',
  el: 'GR',
  pl: 'PL',
  sv: 'SE',
  ro: 'RO',
} as const;

export const mapSupportedLocales = (locale: string) => {
  if (locale.includes('-')) {
    return locale;
  }

  return localeToCountryCode[locale] ? `${locale}-${localeToCountryCode[locale]}` : DEFAULT_LOCALE;
};
